/**
 * <Icon name="back"/>
 * @file: Icon.js
 * @desc: 字体图标
 * @usage
 * @providesModule Icon
 */

import React from 'react';

import { StyleSheet, Text, TouchableOpacity, TextStyle, ViewStyle, RegisteredStyle } from 'react-native';

/**
 * icon name map
 * @type {Object}
 */
const ICON = {
    maskClose: '\ue5a3',
    warning: '\ue6b5',
    newup: '\ue3f6',
    // 向下箭头
    // newdown: '\uf3c7',
    newdown: '\ue3f7'
};

const defaultProps = {
    name: 'back',
    color: null,
    size: null,
    style: null
};

export interface IconProps {
    name: string;
    color?: string;
    onPress?: () => void;
    size?: number;
    style?: ViewStyle | TextStyle | null | RegisteredStyle<ViewStyle | TextStyle>;
}

class Icon extends React.PureComponent<IconProps> {
    static defaultProps = defaultProps;
    render() {
        if (this.props.onPress) {
            return (
                <TouchableOpacity onPress={this.props.onPress} style={this.props.style}>
                    <Text style={this.getStyle()}>{this.getIconText()}</Text>
                </TouchableOpacity>
            );
        }
        return (
            <Text onPress={this.props.onPress} style={this.props.style}>
                <Text style={this.getStyle()}>{this.getIconText()}</Text>
            </Text>
        );
    }

    getIconText() {
        const icon: string | undefined = ICON[this.props.name];
        return icon || this.props.name;
    }

    getStyle() {
        const { props } = this;
        return [
            styles.font,
            props.color ? { color: props.color } : null,
            props.size ? { fontSize: props.size } : null
        ];
    }
}

const styles = StyleSheet.create({
    font: {
        fontFamily: 'cmn_component_order-0_0_9',
        color: '#2aa9b9',
        fontSize: 16,
        backgroundColor: 'rgba(0,0,0,0)'
    }
});

export default Icon;
